import React from "react";
import { FormItem } from "..";
import { InputGroup } from "react-bootstrap";

const validations = ["tel"];
class TelText extends FormItem {
  constructor(props) {
    super(props);
    const self = this;
    self.defineValidations(validations);
    self.refList = [React.createRef(), React.createRef(), React.createRef()];
    self.maxLengthList = [4, 4, 4]; // eslint-disable-line no-magic-numbers
    self.onChange = self.onChange.bind(self);
  }
  getValues() {
    const self = this;
    return (self.getVal() || "--").split("-");
  }
  onChange(index, value) {
    const self = this;
    const values = self.getValues();
    values[index] = value
      .replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248))
      .replace(/[^\d]/g, "");
    self.setVal(values.join("-"));
    if (self.refList[index + 1] && value.length >= self.maxLengthList[index]) {
      self.refList[index + 1].current.focus();
    }
  }
  renderReadonly() {
    const self = this;
    return <p className="mb-0">{self.getVal() || ""}</p>;
  }
  renderInput() {
    const self = this;
    const formControlClassName = self.getFormControlClassName();
    const values = self.getValues();
    const inputStyle = { maxWidth: "3.5em" };
    return (
      <div>
        <div className="form-inline">
          <InputGroup className="w-auto">
            <input
              ref={self.refList[0]}
              type="tel"
              className={formControlClassName}
              value={values[0] || ""}
              maxLength={self.maxLengthList[0]}
              style={inputStyle}
              onChange={event => self.onChange(0, event.target.value)}
            />
          </InputGroup>
          <span className="mx-1">―</span>
          <InputGroup className="w-auto">
            <input
              ref={self.refList[1]}
              type="tel"
              className={formControlClassName}
              value={values[1] || ""}
              maxLength={self.maxLengthList[1]}
              style={inputStyle}
              onChange={event => self.onChange(1, event.target.value)}
            />
          </InputGroup>
          <span className="mx-1">―</span>
          <InputGroup className="w-auto">
            <input
              ref={self.refList[2]}
              type="tel"
              className={formControlClassName}
              value={values[2] || ""}
              maxLength={self.maxLengthList[2]}
              style={inputStyle}
              onChange={event => self.onChange(2, event.target.value)}
            />
          </InputGroup>
        </div>
        {self.renderValError()}
      </div>
    );
  }
}
export default TelText;
